{
    "api_keys": {
        "revoke": {
            "title": "API-Schlüssel widerrufen",
            "message": "Durch das Widerrufen eines API-Schlüssels verlieren alle Anwendungen, die ihn verwenden, sofort den Zugriff.",
            "confirm": "Widerrufen",
            "cancel": "Abbrechen"
        }
    },
    "request": {
        "cancel": {
            "title": "Antrag abbrechen",
            "message": "Möchten Sie diesen Antrag wirklich abbrechen?",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "delete": {
            "title": "Antrag löschen",
            "message": "Möchten Sie diesen Antrag wirklich löschen?",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "auto_approver": {
            "title": "Automatische Genehmigung",
            "message": "Dieser Antrag wird automatisch genehmigt, da der Auto Approver als Genehmiger:in ausgewählt wurde. Ist dies Ihre Absicht?",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "amounts_mismatch": {
            "title": "Unterschiedliche Beträge",
            "message": "Die Summe der Artikel Nettobeträge oder Steuersätze unterscheidet sich von der Gesamt-Zeile. Soll diese angepasst werden?",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "datev_warning": {
            "title": "Warnung",
            "message": "Die Rechnungsnummer dieses Antrags enthält Zeichen, die DATEV nicht akzeptiert. Diese werden beim Export entfernt.",
            "message_multiple": "Mindestens eine Rechnungsnummer von diesen Anträgen enthält Zeichen, die DATEV nicht akzeptiert. Diese werden beim Export entfernt.",
            "confirm": "Weiter",
            "cancel": "Zurück"
        },
        "duplicate": {
            "invoice_file": {
                "title": "Duplikat Warnung",
                "message_one": "Diese Datei wurde bereits für ",
                "message_two": " hochgeladen und könnte ein Duplikat andeuten. Möchten Sie dennoch fortfahren?",
                "confirm": "Weiter",
                "cancel": "Zurück"
            },
            "invoice_number": {
                "title": "Duplikat Warnung",
                "message_one": "Diese Rechnungsnummer stimmt mit ",
                "message_two": " überein und könnte ein Duplikat andeuten. Möchten Sie dennoch fortfahren?",
                "confirm": "Weiter",
                "cancel": "Zurück"
            }
        },
        "performance_date_out_of_range": {
            "title_date": "Ungewöhnliches Leistungsdatum",
            "title_period": "Ungewöhnlicher Leistungszeitraum",
            "message_date_past": "Das Leistungsdatum liegt mehr als drei Jahre zurück. Das ist ungewöhnlich, kann aber zulässig sein. Möchten Sie fortfahren?",
            "message_date_future": "Das Leistungsdatum liegt mehr als drei Jahre in der Zukunft. Das ist ungewöhnlich, kann aber zulässig sein. Möchten Sie fortfahren?",
            "message_period_past": "Der Leistungszeitraum liegt mehr als drei Jahre zurück. Das ist ungewöhnlich, kann aber zulässig sein. Möchten Sie fortfahren?",
            "message_period_future": "Der Leistungszeitraum liegt mehr als drei Jahre in der Zukunft. Das ist ungewöhnlich, kann aber zulässig sein. Möchten Sie fortfahren?",
            "confirm": "Weiter",
            "cancel": "Zurück"
        },
        "status_advancement": {
            "title": "Status-Aktualisierung durch den Export",
            "message_one": "Bitte geben Sie an, ob der Status der exportierten Anträge im Status “bezahlt“ auf den Status “exportiert“ aktualisiert werden soll oder nicht. Die Status-Aktualisierung gilt nur für DATEV- und CSV-Exporte, nicht für den Export von Rechnungen oder Alle Formate.",
            "message_two": "Status für ausgewählte Anträge im Status “bezahlt” auf “exportiert” aktualisieren.",
            "confirm": "Exportieren",
            "cancel": "Abbrechen"
        },
        "reset_status": {
            "title": "Warnung",
            "message": {
                "pending": "Wenn Sie diesen Antrag zurücksetzen, wird der Genehmigungsprozess zurückgesetzt und alle darauf vorgenommenen Genehmigungen gehen verloren. Möchten Sie den Status diesen Antrag wirklich zurücksetzen?",
                "discount_applied": "Dieser Antrag weist Skonto auf. Wenn Sie den Status dieses Antrags zurücksetzen, wird Skonto entfernt. Sind Sie sicher, dass Sie den Status dieses Antrags zurücksetzen wollen?",
                "default": "Sind Sie sicher, dass Sie den Status dieses Antrags zurücksetzen wollen?"
            },
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "reset_status_folder": {
            "title": "Warnung",
            "message": "Sind Sie sicher, dass Sie den Status diese Reise zurücksetzen wollen?",
            "pending_request_message": "Wenn Sie diese Reise zurücksetzen, wird der Genehmigungsprozess zurückgesetzt und alle darauf vorgenommenen Genehmigungen gehen verloren. Möchten Sie den Status diese Reise wirklich zurücksetzen?",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "submit_folder_with_different_currencies": {
            "title": "Bitte einen Moment warten - Reise enthält verschiedene Währungen",
            "message": "Bitte warten Sie kurz, während wir den Gesamtbetrag dieser Reise basierend auf den heutigen Wechselkursen neu berechnen. Sobald dies abgeschlossen ist, kann es sein, dass Sie die Reise erneut einreichen müssen.",
            "confirm": "Verstanden."
        },
        "restore": {
            "title": "Warnung",
            "message": "Sind Sie sicher, dass Sie diesen Antrag wiederherstellen wollen?",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "tax_mismatch": {
            "title": "Diskrepanz zwischen den Steuersätzen",
            "message": "Der Steuersatz für die Rechnungssplits stimmt nicht mit dem Gesamtsteuerbetrag dieses Antrags überein. Soll dies angepasst werden?",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "queued_export": {
            "title": "Export gestartet",
            "message": "Der Export wurde gestartet und wird in den nächsten Minuten fertiggestellt.",
            "confirm": "Ok"
        },
        "per_diem_less_than_8h": {
            "title": "Keine Verpflegungsmehraufwands-Erstattung",
            "message": "Ihre Abwesenheit betrug 8 Stunden oder weniger, deshalb finden die Tagespauschalen keine Anwendung.",
            "confirm": "Ok"
        },
        "admin_not_own_approval": {
            "title": "Warnung",
            "message": "Sie werden diesen Antrag für {{name}} genehmigen. Möchten Sie wirklich fortfahren?",
            "folder_approval_message": "Sie werden diese Reise für {{name}} genehmigen. Möchten Sie wirklich fortfahren?",
            "purchase_order_approval_message": "Sie werden diese Bestellung für {{name}} genehmigen. Möchten Sie wirklich fortfahren?",
            "confirm": "Genehmigen",
            "cancel": "Abbrechen"
        },
        "detach": {
            "title": "Antrag aus der Reise entfernen",
            "message": "Sind Sie sicher, dass Sie diesen Antrag aus der Reise entfernen möchten? Ein anderer Freigabeprozess könnte ausgelöst, und Freigaben zurückgesetzt werden.",
            "confirm": "Ja, entfernen",
            "cancel": "Abbrechen"
        },
        "delete_folder": {
            "title": "Reise löschen",
            "message": "Sind Sie sicher, dass Sie diese Reise löschen möchten? Alle enthaltenen Anträge werden aus der Reise entfernt, nur die Reise wird gelöscht.",
            "confirm": "Ja, löschen",
            "cancel": "Abbrechen"
        },
        "archive_folder": {
            "title": "Reise archivieren",
            "message": "Sind Sie sicher, dass Sie diesen Reise archivieren möchten?",
            "all": "Sind Sie sicher, dass Sie diese Reise einschließlich der darin enthaltenen Anträge archivieren wollen?",
            "extra": "Bitte wählen Sie, welche Elemente Sie archivieren möchten:",
            "confirm": "Archivieren",
            "select": {
                "folder_only": "Nur Reise",
                "all": "Reise & Anträge"
            },
            "cancel": "Abbrechen"
        },
        "unarchive_folder": {
            "title": "Reise ausarchiviert",
            "message": "Sind Sie sicher, dass Sie diesen Reise aus-archivieren möchten?",
            "extra": "Bitte wählen Sie, welche Elemente Sie aus-archivieren möchten:",
            "all": "Sind Sie sicher, dass Sie diese Reise einschließlich der darin enthaltenen Anträge aus-archivieren wollen?",
            "confirm": "Ausarchivieren",
            "select": {
                "folder_only": "Nur Reise",
                "all": "Reise & Anträge"
            },
            "cancel": "Abbrechen"
        },
        "reject_folder": {
            "title": "Reise ablehnen",
            "message": "Der Status dieser Reise ändert sich zu abgelehnt. Alle enthaltenen Anträge werden aus der Reise entfernt und entsprechend Ihres Status dem Dashboard zugeordnet. Für Fragen oder kleine Anmerkungen empfehlen wir, Kommentare zu nutzen. Sind Sie sicher, dass Sie die Reise ablehnen möchten?",
            "confirm": "Ablehnen",
            "cancel": "Abbrechen"
        },
        "gobd_invoice_compliance": {
            "flagging": {
                "title": "GoBD-konformen Beleg",
                "message": "Sind Sie sicher, dass Sie einen GoBD-konformen Beleg mit den angegebenen Informationen erstellen möchten? Sobald der Antrag als \"GoBD-konform\" gekennzeichnet ist, wird dieser unveränderbar und alle Eingabefelder werden gesperrt.",
                "missing_iban": "Bitte beachten Sie: Die IBAN des Lieferanten fehlt. Wenn Sie fortfahren, wird die Zahlung und der SEPA-XML-Download nicht möglich sein. Bitte fügen Sie die IBAN in den <0>Stammdaten des Lieferanten</0> hinzu und synchronisieren Sie die Änderungen vorab.",
                "confirm": "Bestätigen",
                "cancel": "Abbrechen"
            }
        },
        "archive": {
            "title": "Antrag archivieren",
            "title_plural": "Anträge archivieren",
            "message": "Möchten Sie diesen Antrag wirklich archivieren? \n\n Solange der Antrag archiviert ist, können Sie keine Änderungen mehr vornehmen.",
            "message_plural": "Möchten Sie diese Anträge wirklich archivieren? \n\n Solange die Anträge archiviert sind, können Sie keine Änderungen mehr vornehmen.",
            "confirm": "Ja",
            "cancel": "Nein"
        }
    },
    "subscription": {
        "delete": {
            "title": "Abonnement löschen",
            "message": "Möchten Sie dieses Abonnement wirklich löschen? Dabei werden auch alle zu diesem Abonnement zugewiesenen Anträge gelöscht.",
            "message_with_card": "Zudem wird die verknüpfte Karte automatisch geschlossen.",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "item_split_replaces_net_split": {
            "title": "Artikel-Aufteilung ersetzt Netto-Aufteilung (%)",
            "message": "Möchten Sie dieses Abonnement wirklich aktualisieren? Sie haben diesem Abonnement Artikel hinzugefügt. Beim Speichern wird die bisherige <0>Netto-Aufteilung (%)</0> ersetzt. Alle zukünftigen wiederkehrenden Anträge werden dann <0>artikelbasiert</0> statt <0>netto-basiert</0> aufgeteilt.",
            "confirm": "Ja, aktualisieren",
            "cancel": "Nein"
        }
    },
    "transaction": {
        "delete": {
            "title": "Transaktion löschen",
            "message": "Möchten Sie diese Transaktion wirklich löschen?",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "bulk_delete": {
            "title": "Transaktionen löschen",
            "message": "Möchten Sie diese Transaktionen wirklich löschen?"
        }
    },
    "vendor": {
        "delete": {
            "title": "Lieferanten löschen",
            "message": "Möchten Sie diesen Lieferant wirklich löschen?",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "restore": {
            "title": "Lieferant wiederherstellen",
            "name_message": "Ein Lieferant mit diesem Namen existierte bereits in der Vergangenheit. Möchten Sie diesen Lieferant wiederherstellen?",
            "creditor_number_message": "Ein Lieferant mit dieser Kreditorennummer existierte bereits in der Vergangenheit. Möchten Sie diesen Lieferanten wiederherstellen?",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "incompatible_creditor_number": {
            "title": "Kreditorennummer nicht kompatibel mit DATEV",
            "message": "Die Kreditorennummer ist aus folgendem Grund nicht mit DATEV kompatibel: {{reason}} Möchten Sie trotzdem fortfahren?",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "duplicate": {
            "title": "Dieser Lieferant ist potenziell eine Dublette",
            "message": "Ähnliche Lieferanten wurden gefunden. Bitte überprüfen Sie sorgfältig, ob der neue Lieferant bereits in der folgenden Liste hinterlegt ist.",
            "cancel": "Cancel"
        }
    },
    "employee": {
        "delete": {
            "title": "Mitarbeiter:in löschen",
            "message": "Alle Genehmigungsprozesse, in die diese:r Benutzer:in involviert ist, werden neu berechnet und zurückgesetzt. Möchten Sie diese:n Mitarbeiter:in wirklich löschen?",
            "replacement_label": "Bitte wählen Sie eine:n Mitarbeiter:in aus, der/die zu löschende:n Mitarbeiter:in in Workflows ersetzen soll.",
            "confirm": "Ja, löschen",
            "cancel": "Nein"
        },
        "demote": {
            "title": "Rolle der Mitarbeiter:in ändern",
            "message": "Alle Genehmigungsprozesse, in die diese:r Benutzer:in involviert ist, werden neu berechnet und zurückgesetzt. Sind Sie sicher, dass Sie die Rolle dieses/dieser Mitarbeiter:in zu von einer Genehmiger:innen- zu einer Mitarbeiter:innen-Rolle ändern ändern möchten?",
            "replacement_label": "Bitte wählen Sie eine:n Mitarbeiter:in aus, der/die diese:n Mitarbeiter:in mit heruntergestufter Rolle in Workflows ersetzen soll.",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "remove_substitute": {
            "TODO": "Translate",
            "title": "Sind Sie sicher?",
            "message": "Nutzer:in ist aktuell als Vertretung zum Genehmigen eingetragen. Wenn Sie fortfahren, kann er/sie keine Anträge mehr im Namen der hauptverantwortlichen Person genehmigen. Die hauptverantwortliche Person wird informiert und kann eine neue Vertretung wählen.",
            "confirm": "Fortfahren",
            "cancel": "Abbrechen"
        },
        "restore": {
            "title": "Mitarbeiter:in wiederherstellen",
            "message": "Ein:e Mitarbeiter:in mit dieser Email-Adresse war bereits in der Vergangenheit vorhanden. Möchten Sie den/die Mitarbeiter:in wiederherstellen?",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "cannot_be_deleted_because_is_fallback_approver": {
            "title": "Benutzer Rolle kann nicht gelöscht werden",
            "message": "Dieser/diese Benutzer:in ist derzeit als Ersatz-Genehmiger:in dieses Unternehmens eingerichtet und kann daher nicht gelöscht werden. Bitte wählen Sie zuerst eine:n andere:n Benutzer:in als Ersatz-Genehmiger:in aus.",
            "confirm": "Ok, verstanden"
        },
        "enroll_without_date_of_birth": {
            "title": "Kein Geburtsdatum hinterlegt",
            "message": "{{name}} kann jetzt in das Kartenprogramm aufgenommen werden, es kann jedoch keine Karte ausgestellt werden, solange kein Geburtsdatum hinterlegt ist. Nur die Person selbst kann es eintragen und wird beim nächsten Login danach gefragt, bevor sie finway weiter nutzen kann.",
            "confirm": "Trotzdem aufnehmen",
            "cancel": "Abbrechen"
        }
    },
    "cost_center": {
        "delete": {
            "title": "Kostenstelle löschen",
            "message": "Möchten Sie diese Kostenstelle wirklich löschen?",
            "message_shared_note": "Achtung: Alle geteilte Mitarbeiter:innen verlieren Zugriff.",
            "confirm": "Ja, löschen",
            "cancel": "Nein"
        },
        "restore": {
            "title": "Kostenstelle wiederherstellen",
            "message": "Eine Kostenstelle mit dieser ID existierte bereits in der Vergangenheit. Möchten Sie diese Kostenstelle wiederherstellen?",
            "confirm": "Ja",
            "cancel": "Nein",
            "change_responsible_user": "{{newUserName}} wird als verantwortliche:r Benutzer:in der wiederherzustellenden Kostenstelle festgelegt, da der/die ursprünglich verantwortliche Mitarbeiter:in, {{originalUserName}}, nicht über ausreichende Rollenrechte verfügt. Möchten Sie fortfahren?"
        },
        "budget_period_change": {
            "title": "Kostenstellenbudgetperiode ändern",
            "message": "Möchten Sie den Budgetzeitraum wirklich ändern? Wenn Sie fortfahren, gehen alle alternativen Budgets verloren, die Sie für diese Kostenstelle eingerichtet haben.",
            "confirm": "Ja, Zeitraum ändern",
            "cancel": "Nein"
        }
    },
    "comment": {
        "delete": {
            "title": "Kommentar löschen",
            "message": "Möchten Sie dieses Kommentar wirklich löschen?",
            "confirm": "Ja, löschen",
            "cancel": "Nein"
        }
    },
    "file": {
        "delete_from_server": {
            "title": "Warnung",
            "message": "Möchten Sie diese Datei wirklich dauerhaft löschen?",
            "confirm": "Ja, löschen",
            "cancel": "Nein"
        }
    },
    "payment_subscription": {
        "reactivate": {
            "title": "Zahlungsabonnement reaktivieren",
            "message": "Möchten Sie Ihr Zahlungsabonnement wirklich wieder aktivieren?",
            "confirm": "Reaktivieren",
            "cancel": "Nein"
        },
        "cancel": {
            "title": "Zahlungsabonnement kündigen",
            "message": "Möchten Sie Ihr Zahlungsabonnement wirklich kündigen?",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "error": {
            "title": "Zahlung fehlgeschlagen",
            "message": "Ihre Zahlung ist fehlgeschlagen. Bitte versuchen Sie es erneut oder nutzen Sie eine andere Karte.",
            "cancel": "Löschen",
            "confirm": "Versuchen Sie es mit einer anderen Karte"
        },
        "delete": {
            "title": "Zahlungsabonnement löschen",
            "message": "Möchten Sie Ihr Zahlungsabonnement wirklich löschen?",
            "cancel": "Nein",
            "confirm": "Ja"
        }
    },
    "banking": {
        "delete": {
            "title": "Bankverbindung löschen",
            "message": "Möchten Sie Ihre Bankverbindung wirklich löschen?",
            "warning": "Achtung: Kategorisierung wird gesperrt für Transaktionen die von dieser Bankverbindung importiert wurden.",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "account": {
            "delete": {
                "title": "Bankaccount löschen",
                "message": "Möchten Sie diesen Account wirklich löschen?",
                "confirm": "Ja",
                "cancel": "Nein"
            }
        },
        "force_reset_payment_status": {
            "title": "Neue Zahlung starten?",
            "message_pending": "Ihre Zahlung ist seit {{days}} Tagen ausstehend.",
            "message_double_payment": "Das Starten eines neuen Zahlungsversuchs kann zu einer Doppelzahlung führen, falls die ursprüngliche Zahlung später noch von Ihrer Bank oder Ihrem Zahlungsanbieter verarbeitet wird. Bitte prüfen Sie vor dem Fortfahren Ihr Online-Banking oder Ihre Zahlungsübersicht, um sicherzustellen, dass die ursprüngliche Zahlung nicht bereits durchgeführt wurde.",
            "message_risk": "Mit dem Fortfahren bestätigen Sie, dass der Neustart der Zahlung auf eigenes Risiko erfolgt.",
            "message_confirm": "Geben Sie zur Bestätigung {{keyword}} ein, um fortzufahren.",
            "placeholder": "NEUSTART",
            "keyword": "NEUSTART",
            "mismatch_title": "Bestätigung erforderlich",
            "mismatch_message": "Bitte geben Sie das Bestätigungswort exakt wie angezeigt ein.",
            "confirm": "Fortfahren",
            "cancel": "Abbrechen"
        }
    },
    "cards": {
        "suspend": {
            "title": "Karte deaktivieren",
            "message": "Sind Sie sicher, dass Sie diese Karte deaktivieren möchten? Dadurch wird das gesamte Guthaben bei Prepaid-Karten von der Karte entfernt und in das finway-Wallet übertragen.",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "close": {
            "title": "Karte schließen",
            "message": "Sind Sie sicher, dass Sie diese Karte unwiderruflich schließen möchten? Dadurch wird das gesamte Guthaben bei Prepaid-Karten von der Karte entfernt und in das finway-Wallet übertragen.",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "report_stolen": {
            "title": "Karte als gestohlen markieren",
            "message": "Sind Sie sicher, dass Sie diese Karte als gestohlen melden möchten? Dadurch wird das gesamte Guthaben bei Prepaid-Karten von der Karte entfernt und in das finway-Wallet übertragen und die Karte unwiderruflich geschloßen.",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "report_lost": {
            "title": "Karte als verloren markieren",
            "message": "Sind Sie sicher, dass Sie diese Karte als verloren melden möchten? Dadurch wird das gesamte Guthaben bei Prepaid-Karten von der Karte entfernt und in das finway-Wallet übertragen und die Karte unwiderruflich geschloßen.",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "kyb_start": {
            "title": "KYB Warnung",
            "message_start": "Lieber Kunde, Sie starten gerade damit den KYB Prozess zur Freischaltung der Karten zu beginnen. Bitte überprüfen Sie, ob Sie die richtige Person hierfür sind - sollte dies im Nachgang geändert werden müssen, ist dies mit viel Aufwand sowie ggf. Mit Kosten für Sie verbunden.",
            "message_point_1": "Sie haben sich das KYB Prozess Dokument in unserem Hilfe-Center gelesen",
            "message_point_2": "Sie haben Prokura in Ihrem Unternehmen oder sind Weisungsberechtigt oder haben eine Vollmacht eines Weisungsberechtigten ausgestellt bekommen",
            "message_point_3": "Sie haben die Dokumente, die im KYB Prozess Dokument beschrieben worden sind parat",
            "message_point_4": "Sie haben Rücksprache mit Ihrem Customer Success Manager gehalten",
            "message_end": "Diese Punkte treffen alle auf Sie zu? Dann klicken Sie weiter.",
            "confirm": "Weiter",
            "cancel": "Abbrechen"
        },
        "limit_update": {
            "title": "Anpassung des Kartenlimits",
            "message": "Möchten Sie das Limit der Karte an den neuen Betrag des Antrags anpassen?",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "physical_card_delivery": {
            "title": "Zustellung der physischen Karte",
            "message": "Wurde Ihre physische Karte bereits zugestellt? Sie sollten eine Karte nur aktivieren, nachdem Sie sie erhalten haben.",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "payment_flow_info_reset": {
            "title": "Zurücksetzung des Bezahlungsstatus",
            "message": "Dieses Abonnement hat einen Bezahlungsstatus gesetzt. Durch das Erstellen einer Karte wird dieser für das Abonnement und alle künftigen wiederkehrenden Zahlungen entfernt. Sind Sie sicher, dass Sie fortfahren wollen?",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "payment_flow_info_reporting_only_on_creation": {
            "title": "Bezahlungsstatus \"nur für Reporting\"",
            "message": "Sind Sie sicher, dass Sie diesen Antrag einreichen möchten? Der Bezahlungsstatus \"nur für Reporting\" kann nicht mehr geändert werden. Der Export in Buchhaltungstools, z.B. in DUO, ist dann nicht mehr möglich.",
            "confirm": "Antrag einreichen",
            "cancel": "Abbrechen"
        },
        "payment_flow_info_already_paid_on_review": {
            "title": "Bezahlungsstatus \"bereits bezahlt\"",
            "message": "Sind Sie sicher, dass Sie diesen Antrag als geprüft markieren möchten? Wenn der Bezahlungsstatus \"bereits bezahlt\" ausgewählt ist, wird der Bezahlungsschritt übersprungen.",
            "confirm": "Antrag einreichen",
            "cancel": "Abbrechen"
        },
        "payment_flow_info_already_approved_and_paid_on_review": {
            "title": "Bezahlungsstatus \"genehmigt & bezahlt\"",
            "message": "Sind Sie sicher, dass Sie diesen Antrag als geprüft markieren möchten? Wenn der Bezahlungsstatus \"genehmigt & bezahlt\" ausgewählt ist, wird der Bezahlungsschritt übersprungen.",
            "confirm": "Antrag einreichen",
            "cancel": "Abbrechen"
        },
        "payment_flow_info_on_bulk_review": {
            "title": "Bezahlungsstatus gesetzt",
            "message": "Mind. einer dieser Anträge hat einen Bezahlungsstatus gesetzt. Sind Sie sicher, dass Sie alle Anträge als geprüft markieren möchten? Der Bezahlungsschritt wird ggfs. für Anträge mit einem Bezahlungsstatus übersprungen.",
            "confirm": "Anträge einreichen",
            "cancel": "Abbrechen"
        },
        "non_euro_wallet": {
            "title": "Non-Euro Wallet",
            "message": "Sind Sie sicher, dass Sie nicht Euro als die Basiswährung Ihres finway Wallets und Karten möchten? Dies kann nicht mehr geändert werden.",
            "confirm": "Ja",
            "cancel": "Nein"
        }
    },
    "workflow": {
        "delete": {
            "title": "Workflow löschen",
            "message": "Sind Sie sicher, dass Sie diesen Workflow löschen möchten?",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "recalculate_approval_processes_in_progress": {
            "title": "Aktive Genehmigungsprozesse neu berechnen",
            "message": "Alle Genehmigungsprozesse, die von diesem Workflow abhängen, werden neu berechnet und zurückgesetzt. Alle aktuellen Genehmigungen werden zurückgesetzt. Möchten Sie wirklich fortfahren?"
        }
    },
    "approval_process": {
        "recalculate_in_progress": {
            "title": "Aktive Freigabeprozesse werden geändert",
            "message": "Der Freigabeprozess dieses Antrags ändert sich. Bisherige Freigaben werden zurückgesetzt.",
            "current_workflow_title": "Bestehender Workflow",
            "updated_workflow_title": "Aktualisierter Workflow",
            "ocr_title": "OCR-Aktualisierungen auf diesen Antrag anwenden",
            "ocr_message": "Der Genehmigungsprozess für diese Ausgabe wird sich nach der Anwendung von OCR ändern und alle zuvor genehmigten Prozesse werden zurückgesetzt.",
            "folder_amount_message": "Der Freigabeprozess dieser Reise und alle vorherigen Genehmigungen werden zurückgesetzt.",
            "detached_expense_message": "Dieser Freigabeprozess und alle vorherigen Genehmigungen werden zurückgesetzt. Außerdem wird der Reisefreigabeprozess zurückgesetzt.",
            "continue_process": "Sind Sie sicher, dass Sie fortfahren möchten?",
            "update_or_delete_workflow_message": "Alle Freigabeprozesse, die auf diesem Workflow basieren, werden neu berechnet. Bisherige Freigaben werden zurückgesetzt. Möchten Sie dennoch fortfahren?"
        }
    },
    "company": {
        "delete": {
            "title": "Sind Sie sicher, dass Sie diese Firma löschen möchten?",
            "message": "Die Firma wird in den Bereich „Gelöscht“ verschoben. Der Zugriff entfällt und die DUO-Integration wird getrennt. Bei Wiederherstellung werden die Daten wiederhergestellt, DUO muss jedoch neu eingerichtet werden.",
            "confirm": "Ja, löschen",
            "cancel": "Nein"
        },
        "restore": {
            "title": "Sind Sie sicher, dass Sie dieses Unternehmen wiederherstellen wollen?",
            "message": "Alle Daten zu diesem Unternehmen werden wiederhergestellt.",
            "confirm": "Ja",
            "cancel": "Nein"
        }
    },
    "export": {
        "duplicate_datev_online": {
            "title": "Doppelter DUO Export",
            "message_singular": " ist bereits nach DUO exportiert worden. Sind Sie sicher, dass Sie diesen Antrag nochmals exportieren wollen?",
            "message_plural": " sind bereits nach DUO exportiert worden. Sind Sie sicher, dass Sie diese Anträge nochmals exportieren wollen?",
            "confirm": "Ja",
            "cancel": "Nein"
        }
    },
    "liquidity": {
        "delete_scenario": {
            "title": "Sind Sie sicher, dass Sie dieses Szenario löschen wollen?",
            "message": "Alle Daten, die sich auf dieses Szenario beziehen, werden gelöscht.",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "delete_forecast_rule": {
            "title": "Prognoseregel löschen",
            "message": "Möchten Sie diese Prognoseregel wirklich löschen?",
            "confirm": "Ja",
            "cancel": "Nein"
        }
    },
    "datev": {
        "bu_code": {
            "title": "DATEV inkompatible BU Codes",
            "message": "DATEV erlaubt nur maximal 4 Ziffern ohne führende Null als einen BU Code. Möchten Sie trotzdem fortfahren?",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "expense_account_code": {
            "title": "DATEV inkompatible(r) Sachkontent Code(s)",
            "message": "DATEV erlaubt nur numerische, positive Werte mit maximal 8 Ziffern ohne führende Null als ein Sachkonto Code. Möchten Sie trotzdem fortfahren?",
            "confirm": "Ja",
            "cancel": "Nein"
        }
    },
    "transaction_category": {
        "delete": {
            "title": "Transaktions-Kategorie löschen",
            "message": "Möchten Sie diese Transaktions-Kategorie wirklich löschen?",
            "confirm": "Ja, löschen",
            "cancel": "Abbrechen"
        }
    },
    "expenseTag": {
        "delete": {
            "title": "Benutzer definierten Tag löschen",
            "message": "Sind Sie sicher, dass Sie das Tag {{expenseTagName}} löschen möchten? Es wird in {{count}} Antrag verwendet.",
            "message_other": "Sind Sie sicher, dass Sie das Tag {{expenseTagName}} löschen möchten? Es wird in {{count}} Anträgen verwendet.",
            "confirm": "Ja, löschen",
            "cancel": "Abbrechen"
        }
    },
    "direct_debit_agreement": {
        "title": "Vereinbarung zur wiederkehrenden Lastschrift",
        "message": "Sofern Sie eine Zahlungsweise per Bankeinzug wählen, wenden wir dabei das SEPA-Lastschriftverfahren an. Sobald Sie das Lastschriftmandat ausgefüllt und eingereicht haben, vergeben wir eine Mandats-referenznummer. Damit ermächtigen Sie uns, wiederkehrend den entsprechenden Betrag von Ihrem ausgewählten Bankkonto einzuziehen. Bei der ersten Rechnung senden wir Ihnen eine Vorankündigung zum wiederkehrenden Zahlungseinzug und kündigen damit die Lastschrift 14 Tage vorher an. Bei allen weiteren Rechnungen findet keine Vorankündigung mehr statt. Wir ziehen die Lastschrift dann gemäß den Vereinbarungen in der Vorankündigung, bzw. 1 Werktag nach Rechnungsstellung ein.\n\nIm Fall einer Rücklastschrift (z. B. mangels erforderlicher Deckung des Kontos, wegen Erlöschen der Kontos, unberechtigten Widerspruchs des Kontoinhabers oder falscher Eingabe der Kontodaten) ermächtigen Sie die finway GmbH , die Lastschrift für die jeweils fällige Zahlungsverpflichtung ein weiteres Mal einzureichen. In diesem Fall sind Sie verpflichtet, die durch die Rücklastschrift entstehenden Kosten zu tragen. Weitergehende Forderungen sind vorbehalten.\n\nWenn Sie dieser Lastschriftvereinbarung zustimmen, ermächtigen Sie die finway GmbH, wiederkehrende Zahlungen von Ihrem Konto mittels Lastschrift einzuziehen. Zugleich weisen wir unser Kreditinstitut an, die von der finway GmbH auf unser Konto gezogenen Lastschriften einzulösen.\n\nHinweis: Wir können innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Vertrages verlangen. Dabei gelten die mit unserem Kreditinstitut vereinbarten Bedingungen."
    },
    "delete_role": {
        "title": "Rolle löschen",
        "message": "Wenn Sie eine Rolle löschen, werden die Rechte der Benutzer:innen mit dieser Rolle automatisch auf die Rechte einer Mitarbeiter:innen-Rolle beschränkt.",
        "confirm": "Löschen",
        "cancel": "Abbrechen"
    },
    "csv_settings": {
        "delete": {
            "title": "Löschen der ausgewählten Vorlage",
            "message": "Sind Sie sicher, dass sie die ausgewählte Vorlage Löschen wollen? Eine Wiederherstellung ist nicht möglich.",
            "confirm": "Löschen",
            "cancel": "Abbrechen"
        }
    },
    "expense_account_settings": {
        "bulk_delete": {
            "title": "Sachkonto/Sachkonten löschen",
            "confirm": "Ja, löschen",
            "cancel": "Nein",
            "message": "Sind Sie sicher, dass Sie dieses Sachkonto löschen möchten?",
            "message_other": "Sind Sie sicher, dass Sie diese {{count}} ausgewählten Sachkonten löschen möchten?"
        }
    },
    "cost_center_2_settings": {
        "bulk_delete": {
            "title": "Kostenträger löschen",
            "confirm": "Ja, löschen",
            "cancel": "Nein",
            "message": "Sind Sie sicher, dass Sie diesen Kostenträger löschen möchten?",
            "message_other": "Sind Sie sicher, dass Sie diese {{count}} ausgewählten Kostenträger löschen möchten?"
        }
    },
    "trip_folder": {
        "delete": {
            "title": "Reise löschen",
            "message": "Sind Sie sicher, dass Sie diese Reise löschen möchten? Alle enthaltenen Anträge werden aus der Reise entfernt, nur die Reise wird gelöscht.",
            "cancel": "Abbrechen",
            "confirm": "Ja, löschen"
        }
    },
    "edit_right_restricted": {
        "title": "Eingeschränkte Rollenaktualisierung",
        "message": "Eine oder mehrere Rechteaktualisierungen können aufgrund von Konflikten nicht durchgeführt werden. Bitte beheben Sie diese, bevor Sie fortfahren.",
        "confirm": "Abbrechen",
        "approval_right": {
            "title": "Funktion: Freigaben. Bearbeitungsrecht (Anträge)",
            "message": "Das Genehmigungsrecht kann den folgenden Benutzer:innen  nicht entzogen werden, da sie Genehmiger:innen von Anträgen und/oder Workflows sind.",
            "expenses": "Antrag {{list}} in Firma {{companyName}}.",
            "workflows": "Workflows # {{list}} in Firma {{companyName}}."
        }
    },
    "session_conflict": {
        "title": "Sie wurden abgemeldet!",
        "message": "Sie wurden automatisch abgemeldet, da eine Anmeldung auf einem anderen Gerät erkannt wurde. Wenn Sie das nicht waren, sichern Sie bitte Ihr Konto, indem Sie Ihr Passwort ändern. Wenn Sie es waren, können Sie diese Nachricht ignorieren.",
        "action": "Okay"
    },
    "discount": {
        "apply_expired": {
            "title": "Zeitfenster für den Skontoabzug abgelaufen",
            "message": "Das Zeitfenster für den Skontoabzug ist abgelaufen. Durch Ihre Bestätigung wird der Skontoabzug trotzdem diesem Antrag hinzugefügt.",
            "confirm": "Bestätigen",
            "cancel": "Abbrechen"
        }
    },
    "unsaved_changes": {
        "title": "Ungespeicherte Änderungen",
        "message": "Wenn Sie die Seite verlassen, verlieren Sie Ihre Eingaben in diesem Modalfenster. Möchten Sie fortfahren?",
        "confirm": "Änderungen verwerfen",
        "cancel": "Bearbeitung fortsetzen"
    },
    "no_request_sync": {
        "title": "Keine Synchronisation ausgewählt",
        "message": "Möchten Sie, dass diese Änderungen auch in den Anträgen, die diese Resource verwenden, synchronisieren werden?",
        "cancel": "Nein, nicht synchronisieren",
        "confirm": "Ja, synchronisieren"
    },
    "reset_demo_data": {
        "title": "Demodaten zurücksetzen",
        "message": "Möchten Sie die Demodaten wirklich zurücksetzen? Alle Ihre Änderungen und Einstellungen werden zurückgesetzt.",
        "cancel": "Nein",
        "confirm": "Ja, zurücksetzen"
    },
    "inbox_invoice": {
        "assign_colleague": {
            "title": "Möchten Sie {{name}} dieses Dokument zuweisen?",
            "message": "Wenn Sie dieses Dokument {{name}} zuweisen, erhält diese Person Zugriff auf die Datei im Posteingang und kann sie bearbeiten.",
            "confirm": "Bestätigen",
            "cancel": "Abbrechen"
        },
        "unassign_colleague": {
            "title": "Möchten Sie die Zuordnung von {{name}} zu diesem Dokument aufheben?",
            "message": "Wenn Sie die Zuordnung von {{name}} zu diesem Dokument aufheben, wird der Zugriff auf das Dokument für diese Person widerrufen.",
            "confirm": "Bestätigen",
            "cancel": "Abbrechen"
        }
    },
    "tfa": {
        "reset": {
            "title": "Zwei-Faktor-Authentifizierung zurücksetzen",
            "message": "Möchten Sie die Zwei-Faktor-Authentifizierung für diese:n Benutzer:in wirklich zurücksetzen?",
            "cancel": "Nein",
            "confirm": "Ja, zurücksetzen"
        }
    },
    "purchase_order": {
        "delete": {
            "title": "Bestellung löschen",
            "message": "Sind Sie sicher, dass Sie diese Bestellung löschen möchten? Dabei werden auch alle Verknüpfungen zu Rechnungsanträgen und Lieferscheinen entfernt.",
            "cancel": "Nein",
            "confirm": "Ja, löschen"
        },
        "link_mismatching_invoice": {
            "title": "Warnung",
            "message": "Die Bestellnummer auf der Rechnung ({{ poNumberOnInvoice }}) stimmt scheinbar nicht mit der Bestellnummer des Bestellantrags überein ({{ poNumber }}).",
            "cancel": "Abbrechen",
            "confirm": "Trotzdem verknüpfen"
        },
        "link_mismatching_delivery_note": {
            "title": "Warnung",
            "message": "Die Bestellnummer auf dem Lieferschein ({{ poNumberOnDeliveryNote }}) stimmt scheinbar nicht mit der Bestellnummer des Bestellantrags überein ({{ poNumber }}).",
            "cancel": "Abbrechen",
            "confirm": "Trotzdem verknüpfen"
        },
        "reopen_from_completed": {
            "title": "Warnung",
            "message": "Möchten Sie den Status dieser Bestellung wirklich zurücksetzen? Er wird wieder auf „Lieferung“ gesetzt, sodass Sie sie erneut verknüpfen können.",
            "cancel": "Abbrechen",
            "confirm": "Status zurücksetzen"
        },
        "complete": {
            "title": "Warnung: Bestellung noch nicht verknüpft",
            "message": "Diese Bestellung wurde noch nicht mit einer Rechnung verknüpft. <0>Wenn Sie die Bestellung jetzt abschließen, ist die nachträgliche Verknüpfung nicht mehr möglich.</0>",
            "cancel": "Nein",
            "confirm": "Trotzdem abschließen"
        },
        "card_po_complete": {
            "title": "Warnung: Bestellung noch nicht verknüpft",
            "message": "Diese Bestellung wurde noch nicht mit dem zugehörigen Kartenantrag verknüpft. Sobald die Transaktion erstellt wurde, stellt finway die Verknüpfung automatisch her. <0>Wenn Sie die Bestellung jetzt abschließen, ist die nachträgliche Verknüpfung nicht mehr möglich und die Karte wird geschlossen.</0>",
            "cancel": "Nein",
            "confirm": "Trotzdem abschließen"
        }
    },
    "opos": {
        "clear_item": {
            "title": "Posten ausbuchen",
            "message": "Möchten Sie diesen Posten wirklich aus der OPOS-Liste ausschließen? Der Posten wird aus der Liste entfernt, aber bleibt im System erhalten.",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "retrieve_item": {
            "title": "Position zurückholen",
            "message": "Möchten Sie diese Position wieder in die OPOS Liste aufnehmen?",
            "confirm": "Ja",
            "cancel": "Nein"
        },
        "retrieve_items": {
            "title": "Positionen zurückholen",
            "message": "Möchten Sie diese Positionen wieder in die OPOS Liste aufnehmen?",
            "confirm": "Ja",
            "cancel": "Nein"
        }
    },
    "self_issued_receipt": {
        "enable": {
            "title": "Eigenbeleg erstellen",
            "bullet_1": "Ein Eigenbeleg dient als Ersatz für eine Rechnung oder einen Beleg, der nicht existiert oder nicht mehr verfügbar ist.",
            "bullet_2": "Dies sollte als letzter Ausweg betrachtet werden und nur verwendet werden, wenn es keine andere Möglichkeit gibt, die Originalrechnung oder eine Kopie zu erhalten.",
            "bullet_3": "Der Grund und die Art der Kosten müssen angegeben werden.",
            "bullet_4": "Ein Eigenbeleg sollte den Betrag von 250 € nicht überschreiten.",
            "bullet_5": "Für einen Eigenbeleg kann keine Vorsteuer geltend gemacht werden."
        },
        "discard": {
            "title": "Großartig! Ihr Beleg ist verfügbar?",
            "message": "Wenn Sie den Eigenbeleg deaktivieren, können Sie nun den Originalbeleg vorlegen und benötigen den vom System erstellten Eigenbeleg nicht mehr.",
            "confirm": "Eigenbeleg verwerfen",
            "cancel": "Abbrechen"
        }
    },
    "vendor_payments": {
        "cancel": {
            "title": "Lieferantenzahlung {{reference}} stornieren?",
            "message": "Ihre Belege werden freigegeben und können erneut bezahlt oder exportiert werden. Eine bereits im Online-Banking ausgeführte Überweisung wird nicht rückgängig gemacht.",
            "confirm": "Lieferantenzahlung stornieren",
            "cancel": "Behalten"
        }
    }
}
